import client from '../../providers/fetchClient'

export const getOrders = params => client.get('/v3/orders', { params })
